export enum OrgPlanningSupportAccess {
  Yes = 'Yes',
  No = 'No',
  Readonly = 'Readonly'
}
